module.exports = __webpack_public_path__ + "assets/img/box6-img.70b99c45.png";